<template>
  <div class="nr-table-header">
    <div>
      <NrIconButton
        size="small"
        variant="minimal-neutral"
        aria-label="Toggle sidebar"
        :icon="{ name: 'filter', type: filterToggled ? 'solid' : 'regular' }"
        @click="handleSidebarToggle"
      />
      <span class="nr-table-header__count">
        <slot name="count">{{ resultCount }} / {{ totalCount }}</slot>
      </span>
      {{ ' ' }}
      <NrTooltip v-if="tableHeaderTitleTooltip">
        <template v-slot:label>
          {{ tableHeaderTitleTooltip }}
        </template>

        {{ tableHeaderTitle }}
      </NrTooltip>

      <template v-else>{{ tableHeaderTitle }}</template>
    </div>

    <div v-if="enableColumnFilter" ref="dropdown" class="dropdown-filter">
      <NrIconButton
        variant="minimal-neutral"
        :icon="{ name: 'columns', type: 'regular' }"
        title="Change table column visibility"
        aria-label="Change table column visibility"
        @click="toggleColumnFilter"
        :aria-expanded="enableColumnFilter"
        :disabled="!resultCount"
      />

      <div
        v-show="columnFilterToggled"
        id="column-picker"
        class="dropdown-content"
        ref="dropdown-content"
      >
        <form ref="dropdownColumnPicker">
          <div
            class="field"
            v-for="(column, index) in columns"
            :key="`column-${index}`"
          >
            <NrFormInput
              type="checkbox"
              :label="column.label"
              :modelValue="!column.hidden"
              @update:modelValue="updateColumnValue(column, $event)"
            />
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import NrIconButton from '../NrIconButton/nr-icon-button.vue'
import NrTooltip from '../NrTooltip/NrTooltip.vue'
import NrFormInput from '../NrFormInput/nr-form-input.vue'

export default {
  components: { NrIconButton, NrFormInput, NrTooltip },
  props: {
    resultCount: {
      type: Number,
      default: 0
    },
    totalCount: {
      type: Number,
      default: 0
    },
    columns: {
      type: Array,
      default: () => {
        return []
      }
    },
    enableColumnFilter: {
      type: Boolean,
      default: false
    },
    tableHeaderTitle: {
      type: String,
      default: 'results'
    },
    tableHeaderTitleTooltip: {
      type: String
    }
  },
  data() {
    return { filterToggled: false, columnFilterToggled: false }
  },
  methods: {
    handleSidebarToggle() {
      this.filterToggled = !this.filterToggled
      this.$emit('handleSidebarToggle', this.filterToggled)
    },
    toggleColumnFilter() {
      this.columnFilterToggled = !this.columnFilterToggled
    },
    updateColumnValue(column, columnValue) {
      this.$emit('toggleColumnState', { column, columnValue })
    }
  }
}
</script>

<style lang="scss">
@import '../../styles/tokens/tokens.scss';

.nr-table-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: $spacing-4 $spacing-8 $spacing-4 $spacing-4;
  .nr-table-header__count {
    @include body-large-strong;
  }
  .dropdown-filter {
    position: relative;
  }
  .dropdown-content {
    min-width: 15rem;
    padding: $spacing-16;
    text-align: left;
    position: absolute;
    top: 100%;
    right: 0;
    z-index: 3;
    label {
      width: 100%;
    }
  }
}
</style>
